import i18n from "i18next";
import { HazardIdEnum, PolicyDetails, LocationRiskAssessment, PageTabs } from "../hazardIdEnum";
import { digitalElevationModelColorList } from "../../legends/DigitalElevationModelLegend";
import { heightAboveNearestDrainageColorList } from "../../legends/HeightAboveNearestDrainageLegend";
import { coverTypeHazardList } from "./coverTypeHazardsList";
import { populationDensityEurLegendColorList } from "../../legends/PopulationDensityEurLegend";
import { populationDensityUsaLegendColorList } from "../../legends/PopulationDensityUsaLegend";
import { populationDensityWorldLegendColorList } from "../../legends/PopulationDensityWorldLegend";
import { coastDistanceColorsList, crimeDatasetsSweColorList } from "../../util/colors";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

export const socioEnvHazardsList = (): Hazard[] => [
  {
    cysId: HazardIdEnum.EnvironmentDistanceFireStation,
    name: "Distance to Nearest Fire Station",
    // permissions: ["CYS_SOCE_DFIRES"],
    permissions: [PermissionIdEnum.EnvironmentDistanceFireStation],
    colorRange: ["#f9f9f9", "#fff5f0", "#fca486", "#ea372a", "#67000d"],
    description: i18n.t("riskExposureMapExplained.environmentDistanceFireStation"),
    label: `${i18n.t("riskAssessment.environmentDistanceFireStation")}`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },

  {
    cysId: HazardIdEnum.EnvironmentDistanceSchool,
    name: "Distance to Nearest School",
    // permissions: ["CYS_SOCE_DSCHOOLS"],
    permissions: [PermissionIdEnum.EnvironmentDistanceSchool],
    colorRange: ["#f9f9f9", "#fff5f0", "#fca486", "#ea372a", "#67000d"],
    description: i18n.t("riskExposureMapExplained.environmentDistanceSchool"),
    label: `${i18n.t("riskAssessment.environmentDistanceSchool")}`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },

  // Worldcover:
  ...coverTypeHazardList(),

  // Digital elevation, 4 maps:

  {
    cysId: HazardIdEnum.DigitalElevationModelSwe,
    name: "Digital Elevation Model (SWE)",
    // permissions: ["CYS_ENVR_DEM_SWE_COPERNICUS_GLO30"],
    permissions: [PermissionIdEnum.DigitalElevationModelSwe],
    colorRange: digitalElevationModelColorList,
    description: i18n.t("riskExposureMapExplained.digitalElevationModel"),
    label: `${i18n.t("legend.digitalElevationModel")} (SWE)`,
    pages: [LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },

  {
    cysId: HazardIdEnum.DigitalElevationModelIta,
    name: "Digital Elevation Model (ITA)",
    // permissions: ["CYS_ENVR_DEM_ITA_COPERNICUS_GLO30"],
    permissions: [PermissionIdEnum.DigitalElevationModelIta],
    colorRange: digitalElevationModelColorList,
    description: i18n.t("riskExposureMapExplained.digitalElevationModel"),
    label: `${i18n.t("legend.digitalElevationModel")} (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },

  {
    cysId: HazardIdEnum.HeightAboveNearestDrainageSwe,
    name: "Height Above Nearest Drainage (SWE)",
    // permissions: ["CYS_ENVR_HAND_SWE_ASF_COPWORLDDEM30"],
    permissions: [PermissionIdEnum.HeightAboveNearestDrainageSwe],
    colorRange: heightAboveNearestDrainageColorList,
    description: i18n.t("riskExposureMapExplained.heightAboveNearestDrainage"),
    label: `${i18n.t("legend.heightAboveNearestDrainage")} (SWE)`,
    pages: [LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },

  {
    cysId: HazardIdEnum.HeightAboveNearestDrainageIta,
    name: "Height Above Nearest Drainage (ITA)",
    // permissions: ["CYS_ENVR_HAND_ITA_ASF_COPWORLDDEM30"],
    permissions: [PermissionIdEnum.HeightAboveNearestDrainageIta],
    colorRange: heightAboveNearestDrainageColorList,
    description: i18n.t("riskExposureMapExplained.heightAboveNearestDrainage"),
    label: `${i18n.t("legend.heightAboveNearestDrainage")} (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },

  // Population density, 3 maps:
  {
    cysId: HazardIdEnum.PopulationDensityEurStat22021,
    name: "Population Density (EUR)",
    // permissions: ["CYS_SOCE_POPLD_EUR_EUROSTAT_V22021"],
    permissions: [PermissionIdEnum.PopulationDensityEurStat22021],
    colorRange: populationDensityEurLegendColorList,
    description: i18n.t("riskExposureMapExplained.populationDensityEur"),
    label: `${i18n.t("legend.populationDensityEur")}`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },

  {
    cysId: HazardIdEnum.PopulationDensityUsa,
    name: "Population Density (USA)",
    // permissions: ["CYS_SOCE_POPLD_USA_ORNL_LANDSCANUSA"],
    permissions: [PermissionIdEnum.PopulationDensityUsa],
    colorRange: populationDensityUsaLegendColorList,
    description: i18n.t("riskExposureMapExplained.populationDensityUsa"),
    label: `${i18n.t("legend.populationDensityUsa")}`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },

  {
    cysId: HazardIdEnum.PopulationDensityWorld,
    name: "Population Density (World)",
    // permissions: ["CYS_SOCE_POPLD_WRL_ORNL_LANDSCANG"],
    permissions: [PermissionIdEnum.PopulationDensityWorld],
    colorRange: populationDensityWorldLegendColorList,
    description: i18n.t("riskExposureMapExplained.populationDensityWorld"),
    label: `${i18n.t("legend.populationDensityWorld")}`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },
  {
    cysId: HazardIdEnum.DistanceToNearestCoastWorld,
    name: "Distance to Nearest Coast (World)",
    // permissions: ["CYS_ENVR_DCOAST_WRL_NASAOBPG"],
    permissions: [PermissionIdEnum.DistanceToNearestCoastWorld],
    colorRange: coastDistanceColorsList,
    description: i18n.t("riskExposureMapExplained.distanceToTheNearestCoast"),
    label: `${i18n.t("legend.distanceToTheNearestCoast")} (World)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },
  {
    cysId: HazardIdEnum.DistanceToNearestCoastIta,
    name: "Distance to Nearest Coast (Ita)",
    // permissions: ["CYS_ENVR_DCOAST_ITA_NASAOBPG"],
    permissions: [PermissionIdEnum.DistanceToNearestCoastIta],
    colorRange: coastDistanceColorsList,
    description: i18n.t("riskExposureMapExplained.distanceToTheNearestCoast"),
    label: `${i18n.t("legend.distanceToTheNearestCoast")} (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },
  {
    cysId: HazardIdEnum.CrimeDatasetsSwe,
    name: "Crime Datasets (SWE)",
    // permissions: ["CYS_SOCE_CRIME_SWE_MSB_2024"],
    permissions: [PermissionIdEnum.CrimeDatasetsSwe],
    colorRange: crimeDatasetsSweColorList,
    description: i18n.t("riskExposureMapExplained.crimeDatasetsSwe"),
    label: `${i18n.t("riskAssessment.crimeDatasetsSwe")}`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },
];
